/**
 * Simple MDE Markdown Editor Component
 */
import React, { useMemo } from 'react';
import SimpleMDE from 'react-simplemde-editor';
import 'simplemde/dist/simplemde.min.css';

interface MarkdownEditorProps {
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
}

export const MarkdownEditor: React.FC<MarkdownEditorProps> = ({ value, onChange, placeholder }) => {
    const options = useMemo(() => ({
        spellChecker: false,
        placeholder: placeholder || 'Write your content here...',
        status: false,
        autosave: {
            enabled: true,
            uniqueId: 'tpcms-markdown-editor',
            delay: 1000,
        },
        renderingConfig: {
            singleLineBreaks: false,
            codeSyntaxHighlighting: true,
        },
    }), [placeholder]);

    return (
        <div className="markdown-editor-container">
            <SimpleMDE
                value={value}
                onChange={onChange}
                options={options as any}
            />
            <style>{`
                .markdown-editor-container .editor-toolbar {
                    background: var(--bg-secondary);
                    border: 1px solid var(--border-color);
                    border-radius: 8px 8px 0 0;
                    opacity: 1;
                }
                .markdown-editor-container .editor-toolbar a {
                    color: var(--text-primary) !important;
                }
                .markdown-editor-container .editor-toolbar a.active,
                .markdown-editor-container .editor-toolbar a:hover {
                    background: var(--bg-tertiary);
                    border-color: var(--accent);
                }
                .markdown-editor-container .CodeMirror {
                    background: var(--bg-primary);
                    color: var(--text-primary);
                    border: 1px solid var(--border-color);
                    border-top: none;
                    border-radius: 0 0 8px 8px;
                    font-family: 'JetBrains Mono', monospace;
                    font-size: 14px;
                }
                .markdown-editor-container .CodeMirror-cursor {
                    border-left: 2px solid var(--accent);
                }
                .markdown-editor-container .editor-preview {
                    background: var(--bg-primary);
                    color: var(--text-primary);
                }
            `}</style>
        </div>
    );
};
